import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { ReactComponent as UserIcon } from "../icons/user-regular.svg";
import { ReactComponent as LoginIcon } from "../icons/right-to-bracket-solid.svg";
import { ReactComponent as CartIcon } from "../icons/cart-shopping-solid.svg";
import { ReactComponent as SearchIcon } from "../icons/magnifying-glass-solid.svg";
import "./Navbar.css";
import UserLogin from "./UserLogin";
import { useNavigate, Routes, Route, Link, NavLink } from "react-router-dom";
import UserRegister from "./UserRegister";
import Cookies from "js-cookie";
import maze from "../images/maze.jpg";
import newlogo from "../images/landscape-black-logo.png";
import { jwtDecode } from "jwt-decode";
import { AuthContext } from "./AuthContext";
import {
  Container,
  Nav,
  NavDropdown,
  Navbar,
  Offcanvas,
} from "react-bootstrap";

const MyNavbar = ({
  loggedIn,
  setLoggedIn,
  showLoginForm,
  setShowLoginForm,
  sendDataToParent,
}) => {
  const history = useNavigate();
  const [user, setUser] = useState(null);
  const [username, setUsername] = useState(null); // State variable to store the username
  const { accessToken, setToken } = useContext(AuthContext);
  const navigate = useNavigate();
  // State variable to manage dropdown visibility
  const [servicesHover, setServicesHover] = useState(false);
  const [ecommerceHover, setEcommerceHover] = useState(false);
  const [digitalHover, setDigitalHover] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  ///////////////////////////////////////////////////////////////////////
const [servicesOpen, setServicesOpen] = useState(false);
const [ecommerceOpen, setEcommerceOpen] = useState(false);
const[digitalOpen, setDigitalOpen] = useState(false);

const toggleServices = () => { 
  setServicesOpen(prev => !prev);
  setEcommerceOpen(false); // optional: close inner dropdown when Services is toggled
  setDigitalOpen(false);
}

const toggleEcommerce = () => {
  setEcommerceOpen(!ecommerceOpen);
  setDigitalOpen(false)
};

const toggleDigital = () =>{
  setDigitalOpen(!digitalOpen);
  setEcommerceOpen(false)
}
/////////////////////////////////////////////////////////////////////////
  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);

  

  const handleHomeButtonClick = (event) => {
    if (event && event.target) {
      event.target.blur();
    }
  };

  const handleHomeClick = () => {
    navigate("/");
  };
  const handleAboutClick = () => {
    navigate("/about");
  };

  const handleBusClick = () => {
    navigate("/buseq");
  };
  const handleCarClick = () => {
    navigate("/careerpg");
  };

  const handleConClick = () => {
    navigate("/contacts");
  };

  const handleServicesHover = () => {
    setServicesHover(true);
  };

  const handleServicesLeave = () => {
    setServicesHover(false);
  };

  const handleEcommerceHover = () => {
    setEcommerceHover(true);
  };

  const handleEcommerceLeave = () => {
    setEcommerceHover(false);
  };

  const handleDigitalHover = () => {
    setDigitalHover(true);
  };

  const handleDigitalLeave = () => {
    setDigitalHover(false);
  };

  const handleAmazon = () => {
    navigate("/amazon");
  };

  const handleAmazonAccMgmt = () => {
    navigate("/amazon/account-management");
  };

  const handleAmazonAd = () => {
    navigate("/amazon/advertising");
  };
  const handleAmazonRein = () => {
    navigate("/amazon/reinstatement");
  };
  const handleAmazonReg = () => {
    navigate("/amazon/register");
  };
  const handleAmazonPlus = () => {
    navigate("/amazon/aplus");
  };
  const handleAmazonStore = () => {
    navigate("/amazon/store");
  };

  const handleAmazonBrand = () => {
    navigate("/amazon/brand");
  };
  const handleAmazonList = () => {
    navigate("/amazon/listing");
  };

  const handleAmazonImageEdit = () => {
    navigate("/amazon/image-edit");
  };

  const handleFlipkart = () => {
    navigate("/flipkart");
  };

  const handleFlipkartAccMgmt = () => {
    navigate("/flipkart/account-management");
  };

  const handleFlipkartAd = () => {
    navigate("/flipkart/advertising");
  };

  const handleFlipkartRpd = () => {
    navigate("/flipkart/rpd");
  };

  const handleFlipkartReg = () => {
    navigate("/flipkart/reg");
  };

  const handleFlipkartImageEdit = () => {
    navigate("/flipkart/image-edit");
  };

  const handleEcomClick = () => {
    navigate("/ecommerce");
  };

  const handleNykaa = () => {
    navigate("/nykaa");
  };
  const handleJio = () => {
    navigate("/jiomart");
  };

  const handleDigitalMarket = () => {
    navigate("/digital-market");
  };

  const handleProductPhoto = () => {
    navigate("/product-photo");
  };

  const handleSearchEngine = () => {
    navigate("/digital-market/search-engine");
  };

  const handleSocialMedia = () => {
    navigate("/digital-market/social-media");
  };

  const handleContentMarket = () => {
    navigate("/digital-market/content-market");
  };

  const handleEmailMarket = () => {
    navigate("/digital-market/email-market");
  };

  const handleAmazonCampaign = () => {
    navigate("/digital-market/amazon-cam");
  };

  const handleFlipkartCampaign = () => {
    navigate("/digital-market/flipkart-cam");
  };

  const handleImageEdit = () => {
    navigate("/image-editing");
  };

  const handleMultiPort = () => {
    navigate("/multi-portals");
  };

  const handleMeesho = () => {
    navigate("/meesho");
  };
  const handlePerWeb = () => {
    navigate("/perweb");
  };
  const handleAjio = () => {
    navigate("/ajio");
  };
  const handleShopsy = () => {
    navigate("/shopsy");
  };

  const handleMyntra = () => {
    navigate("/myntra");
  };

  const handleEventsPage = () => {
    navigate("/events");
  };

  const handleAllService = () => {
    navigate("/all-services");
  };
  const handleWebDevClick = () => {
    navigate("/web-dev");
  };

  ///////////////////////////////////////////////////////////

  const handleCloseOffcanvas = () => setShowOffcanvas(false);
  const handleShowOffcanvas = () => setShowOffcanvas(true);

  const handleToggleOffcanvas = () => setShowOffcanvas((prev) => !prev);

  return (
    <>
      {/* Conditional rendering of navbar buttons based on the state of showOffcanvas */}
      {!showOffcanvas && (
        <Navbar expand="lg" bg="black" fixed="top"  >
          <Container >
            <Navbar.Brand href="/">
              <img
                src={newlogo}
                alt="Logo"
                style={{
                  maxWidth: "100px",
                  height: "60px",
                  objectFit: "contain",
                }}
                className="logo"
              />
            </Navbar.Brand>
            <Navbar.Toggle className="custom-toggler"
              aria-controls="navbarTogglerDemo02"
              onClick={handleToggleOffcanvas}
              
            />
            <Navbar.Collapse id="navbarTogglerDemo02">
              <Nav className="ms-auto">
                {/* Paste your old <ul> list of menus here */}
                <ul className="navbar-nav justify-content-center">
                  <li className="navbar__category nav-item">
                    <NavLink
                      to="/"
                      className="nav-link px-3 custom-nav-item fw-bold "
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 14,
                      }}
                    >
                      Home
                    </NavLink>
                  </li>
                  <li className="navbar__category nav-item">
                    <NavLink
                      to="/about"
                      className="nav-link px-3 custom-nav-item fw-bold"
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 14,
                      }}
                    >
                      About us
                    </NavLink>
                  </li>
                  <li className="navbar__category nav-item">
                    <NavLink
                      to="/amazon"
                      className="nav-link px-3 custom-nav-item fw-bold"
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 14,
                      }}
                    >
                      Amazon
                    </NavLink>
                  </li>
                  <li className="navbar__category nav-item">
                    <NavLink
                      to="/flipkart"
                      className="nav-link px-3 custom-nav-item fw-bold"
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 14,
                      }}
                    >
                      Flipkart
                    </NavLink>
                  </li>

                  

<li className="navbar__category nav-item">
  <div
    className="dropdown"
    onMouseEnter={handleServicesHover}
    onMouseLeave={handleServicesLeave}
  >
    <NavLink
      to="/all-services"
      className="nav-link px-3 custom-nav-item fw-bold dropdown-toggle"
      style={{ backgroundColor: "black", color: "white", fontSize: 14 }}
      
    >
      Services
    </NavLink>
    <ul className={`dropdown-menu custom-dropdown-menu ${servicesHover ? "show" : ""}`} style={{ left: "0" }}>

      <li className="navbar__category nav-item">
        <div
          className="dropdown"
          onMouseEnter={handleEcommerceHover}
          onMouseLeave={handleEcommerceLeave}
        >
          <NavLink
            to="/ecommerce"
            className="dropdown-item custom-dropdown-item"
            
            style={{ backgroundColor: "black", color: "white" }}
          >
            E-commerce Marketing
          </NavLink>
          <ul className={`dropdown-menu custom-dropdown-menu ${ecommerceHover ? "show" : ""}`} style={{ left: "100%", top: "0" }}>
            <li><NavLink to="/amazon" className="dropdown-item custom-dropdown-item" >Amazon</NavLink></li>
            <li><NavLink to="/amazon/account-management" className="dropdown-item custom-dropdown-item" >Account Management</NavLink></li>
            <li><NavLink to="/amazon/advertising" className="dropdown-item custom-dropdown-item" >Advertising</NavLink></li>
            <li><NavLink to="/amazon/reinstatement" className="dropdown-item custom-dropdown-item" >Account Reinstatement</NavLink></li>
            <li><NavLink to="/amazon/register" className="dropdown-item custom-dropdown-item" >Account Launch and Registration</NavLink></li>
            <li><NavLink to="/amazon/aplus" className="dropdown-item custom-dropdown-item" >A Plus (Enhanced Brand Content)</NavLink></li>
            <li><NavLink to="/amazon/store" className="dropdown-item custom-dropdown-item" >Storefront Creation</NavLink></li>
            <li><NavLink to="/amazon/brand" className="dropdown-item custom-dropdown-item" >Brand and Product-specific Videos</NavLink></li>
            <li><NavLink to="/amazon/listing" className="dropdown-item custom-dropdown-item" >Product Listing</NavLink></li>
            <li><NavLink to="/amazon/image-edit" className="dropdown-item custom-dropdown-item" >Image Editing</NavLink></li>
            <li><NavLink to="/flipkart" className="dropdown-item custom-dropdown-item" >Flipkart</NavLink></li>
            <li><NavLink to="/flipkart/account-management" className="dropdown-item custom-dropdown-item" >Flipkart Account Management</NavLink></li>
            <li><NavLink to="/flipkart/advertising" className="dropdown-item custom-dropdown-item" >Flipkart Advertising</NavLink></li>
            <li><NavLink to="/flipkart/rpd" className="dropdown-item custom-dropdown-item">Flipkart RPD</NavLink></li>
            <li><NavLink to="/flipkart/reg" className="dropdown-item custom-dropdown-item" >Flipkart Account Launch and Registration</NavLink></li>
            <li><NavLink to="/flipkart/image-edit" className="dropdown-item custom-dropdown-item" >Flipkart Image Editing</NavLink></li>
          </ul>
        </div>
      </li>

      <li><NavLink to="/multi-portals" className="dropdown-item custom-dropdown-item" onClick={handleMultiPort}>Cataloging on Multiple Portals</NavLink></li>

      <li className="navbar__category nav-item">
        <div
          className="dropdown"
          onMouseEnter={handleDigitalHover}
          onMouseLeave={handleDigitalLeave}
        >
          <NavLink
            to="/digital-market"
            className="dropdown-item custom-dropdown-item"
            style={{ backgroundColor: "black", color: "white" }}
            
          >
            Digital Marketing
          </NavLink>
          <ul className={`dropdown-menu custom-dropdown-menu ${digitalHover ? "show" : ""}`} style={{ left: "100%", top: "0" }}>
            <li><NavLink to="/digital-market/amazon-cam" className="dropdown-item custom-dropdown-item" >Amazon Campaign Management</NavLink></li>
            <li><NavLink to="/digital-market/flipkart-cam" className="dropdown-item custom-dropdown-item" >Flipkart Campaign Management</NavLink></li>
            <li><NavLink to="/digital-market/search-engine" className="dropdown-item custom-dropdown-item" >Search Engine Optimisation</NavLink></li>
            <li><NavLink to="/digital-market/social-media" className="dropdown-item custom-dropdown-item" >Social Media Marketing</NavLink></li>
            <li><NavLink to="/digital-market/content-market" className="dropdown-item custom-dropdown-item" >Content Marketing</NavLink></li>
            <li><NavLink to="/digital-market/email-market" className="dropdown-item custom-dropdown-item" >Email Marketing</NavLink></li>
          </ul>
        </div>
      </li>

      <li><NavLink to="/image-editing" className="dropdown-item custom-dropdown-item" onClick={handleImageEdit}>Image Editing</NavLink></li>
      <li><NavLink to="/perweb" className="dropdown-item custom-dropdown-item" onClick={handlePerWeb}>Personal Website</NavLink></li>
      <li><NavLink to="/myntra" className="dropdown-item custom-dropdown-item" onClick={handleMyntra}>Myntra</NavLink></li>
      <li><NavLink to="/jiomart" className="dropdown-item custom-dropdown-item" onClick={handleJio}>Jio Mart</NavLink></li>
      <li><NavLink to="/nykaa" className="dropdown-item custom-dropdown-item" onClick={handleNykaa}>Nykaa</NavLink></li>
      <li><NavLink to="/meesho" className="dropdown-item custom-dropdown-item" onClick={handleMeesho}>Meesho</NavLink></li>
      <li><NavLink to="/shopsy" className="dropdown-item custom-dropdown-item" onClick={handleShopsy}>Shopsy</NavLink></li>
      <li><NavLink to="/ajio" className="dropdown-item custom-dropdown-item" onClick={handleAjio}>Ajio</NavLink></li>
    </ul>
  </div>
</li>


                  <li className="navbar__category nav-item">
                    <NavLink
                      to="/buseq"
                      className="nav-link px-3 custom-nav-item fw-bold"
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 14,
                      }}
                    >
                      Business Enquiry
                    </NavLink>
                  </li>
                  <li className="navbar__category nav-item">
                    <NavLink
                      to="/web-dev"
                      className="nav-link px-3 custom-nav-item fw-bold"
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 14,
                      }}
                    >
                      Web Development
                    </NavLink>
                  </li>

                  <li className="navbar__category nav-item">
                    <NavLink
                      to="/careerpg"
                      className="nav-link px-3 custom-nav-item fw-bold"
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 14,
                      }}
                    >
                      Career
                    </NavLink>
                  </li>
                  <li className="navbar__category nav-item">
                    <NavLink
                      to="/contacts"
                      className="nav-link px-3 custom-nav-item fw-bold"
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 14,
                      }}
                    >
                      Contact us
                    </NavLink>
                  </li>
                  <li className="navbar__category nav-item">
                    <NavLink
                      to="/events"
                      className="nav-link px-3 custom-nav-item fw-bold"
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 12,
                      }}
                    >
                      Events
                    </NavLink>
                  </li>
                </ul>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      )}

      <Offcanvas
        show={showOffcanvas}
        onHide={handleToggleOffcanvas}
        placement="start"
        style={{ maxWidth: "300px", backgroundColor: 'black'  }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title style={{ color: "white" }}>
            <img src={newlogo} alt="img-logo"
            style={{
                  maxWidth: "100px",
                  height: "60px",
                  objectFit: "contain",
                }}
                className="logo"/>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {/* Your menu items here */}
          <ul className="navbar-nav justify-content-center">
            <li className="navbar__category nav-item">
              <NavLink
                      to="/"
                      className="nav-link px-3 custom-nav-item fw-bold "
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 20,
                      }}
                    >
                      Home
                    </NavLink>
            </li>
            <li className="navbar__category nav-item">
              <NavLink
                      to="/about"
                      className="nav-link px-3 custom-nav-item fw-bold "
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 20,
                      }}
                    >
                      About us
                    </NavLink>
            </li>
            <li className="navbar__category nav-item">
              <NavLink
                      to="/amazon"
                      className="nav-link px-3 custom-nav-item fw-bold "
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 20,
                      }}
                    >
                      Amazon
                    </NavLink>
            </li>
            <li className="navbar__category nav-item">
              <NavLink
                      to="/flipkart"
                      className="nav-link px-3 custom-nav-item fw-bold "
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 20,
                      }}
                    >
                      Flipkart
                    </NavLink>
            </li>

            <li className="navbar__category nav-item">
              <div
                className="dropdown"
                
              >
                <NavLink
                      to="/all-services"
                      className="nav-link px-3 custom-nav-item fw-bold "
                      onClick={toggleServices}
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 20,
                      }}
                    >
                      Services
                      <span style={{ marginLeft: '50px' }}>
    {servicesOpen ? <i className="bi bi-dash-circle"></i> : <i className="bi bi-plus-circle"></i>}
  </span>
                    </NavLink>
                <ul className={`dropdown-menu custom-dropdown-menu ${servicesOpen ? "show" : ""}`} style={{ left: "0" }}>

      <li className="navbar__category nav-item">
        <div
          className="dropdown eco-color"
          
        >
          <NavLink
            to="/ecommerce"
            className="dropdown-item custom-dropdown-item"
            onClick={toggleEcommerce}
            style={{ backgroundColor: "black", color: "white" }}
          >
            E-commerce Marketing
            <span style={{ marginLeft: '50px' }}>
    {ecommerceOpen ? <i className="bi bi-dash-circle"></i> : <i className="bi bi-plus-circle"></i>}
  </span>
          </NavLink>
          <ul className={`dropdown-menu custom-dropdown-menu ${ecommerceOpen ? "show" : ""} border`} style={{ left: "100%", top: "0" }}>
            <li><NavLink to="/amazon" className="dropdown-item custom-dropdown-item" >Amazon</NavLink></li>
            <li><NavLink to="/amazon/account-management" className="dropdown-item custom-dropdown-item" >Account Management</NavLink></li>
            <li><NavLink to="/amazon/advertising" className="dropdown-item custom-dropdown-item" >Advertising</NavLink></li>
            <li><NavLink to="/amazon/reinstatement" className="dropdown-item custom-dropdown-item" >Account Reinstatement</NavLink></li>
            <li><NavLink to="/amazon/register" className="dropdown-item custom-dropdown-item" >Account Launch and Registration</NavLink></li>
            <li><NavLink to="/amazon/aplus" className="dropdown-item custom-dropdown-item" >A Plus (Enhanced Brand Content)</NavLink></li>
            <li><NavLink to="/amazon/store" className="dropdown-item custom-dropdown-item" >Storefront Creation</NavLink></li>
            <li><NavLink to="/amazon/brand" className="dropdown-item custom-dropdown-item" >Brand and Product-specific Videos</NavLink></li>
            <li><NavLink to="/amazon/listing" className="dropdown-item custom-dropdown-item" >Product Listing</NavLink></li>
            <li><NavLink to="/amazon/image-edit" className="dropdown-item custom-dropdown-item" >Image Editing</NavLink></li>
            <li><NavLink to="/flipkart" className="dropdown-item custom-dropdown-item" >Flipkart</NavLink></li>
            <li><NavLink to="/flipkart/account-management" className="dropdown-item custom-dropdown-item" >Flipkart Account Management</NavLink></li>
            <li><NavLink to="/flipkart/advertising" className="dropdown-item custom-dropdown-item" >Flipkart Advertising</NavLink></li>
            <li><NavLink to="/flipkart/rpd" className="dropdown-item custom-dropdown-item">Flipkart RPD</NavLink></li>
            <li><NavLink to="/flipkart/reg" className="dropdown-item custom-dropdown-item" >Flipkart Account Launch and Registration</NavLink></li>
            <li><NavLink to="/flipkart/image-edit" className="dropdown-item custom-dropdown-item" >Flipkart Image Editing</NavLink></li>
          </ul>
        </div>
      </li>

      <li><NavLink to="/multi-portals" className="dropdown-item custom-dropdown-item" onClick={handleMultiPort}>Cataloging on Multiple Portals</NavLink></li>

      <li className="navbar__category nav-item">
        <div
          className="dropdown dig-color"
          
        >
          <NavLink
            to="/digital-market"
            className="dropdown-item custom-dropdown-item"
            onClick={toggleDigital}
            style={{ backgroundColor: "black", color: "white" }}
            
          >
            Digital Marketing
            <span style={{ marginLeft: '50px' }}>
    {digitalOpen ? <i className="bi bi-dash-circle"></i> : <i className="bi bi-plus-circle"></i>}
  </span>
          </NavLink>
          <ul className={`dropdown-menu custom-dropdown-menu ${digitalOpen ? "show" : ""} border`} style={{ left: "100%", top: "0" }}>
            <li><NavLink to="/digital-market/amazon-cam" className="dropdown-item custom-dropdown-item" >Amazon Campaign Management</NavLink></li>
            <li><NavLink to="/digital-market/flipkart-cam" className="dropdown-item custom-dropdown-item" >Flipkart Campaign Management</NavLink></li>
            <li><NavLink to="/digital-market/search-engine" className="dropdown-item custom-dropdown-item" >Search Engine Optimisation</NavLink></li>
            <li><NavLink to="/digital-market/social-media" className="dropdown-item custom-dropdown-item" >Social Media Marketing</NavLink></li>
            <li><NavLink to="/digital-market/content-market" className="dropdown-item custom-dropdown-item" >Content Marketing</NavLink></li>
            <li><NavLink to="/digital-market/email-market" className="dropdown-item custom-dropdown-item" >Email Marketing</NavLink></li>
          </ul>
        </div>
      </li>

      <li><NavLink to="/image-editing" className="dropdown-item custom-dropdown-item" onClick={handleImageEdit}>Image Editing</NavLink></li>
      <li><NavLink to="/perweb" className="dropdown-item custom-dropdown-item" onClick={handlePerWeb}>Personal Website</NavLink></li>
      <li><NavLink to="/myntra" className="dropdown-item custom-dropdown-item" onClick={handleMyntra}>Myntra</NavLink></li>
      <li><NavLink to="/jiomart" className="dropdown-item custom-dropdown-item" onClick={handleJio}>Jio Mart</NavLink></li>
      <li><NavLink to="/nykaa" className="dropdown-item custom-dropdown-item" onClick={handleNykaa}>Nykaa</NavLink></li>
      <li><NavLink to="/meesho" className="dropdown-item custom-dropdown-item" onClick={handleMeesho}>Meesho</NavLink></li>
      <li><NavLink to="/shopsy" className="dropdown-item custom-dropdown-item" onClick={handleShopsy}>Shopsy</NavLink></li>
      <li><NavLink to="/ajio" className="dropdown-item custom-dropdown-item" onClick={handleAjio}>Ajio</NavLink></li>
    </ul>
              </div>
            </li>

            <li className="navbar__category nav-item">
              <NavLink
                      to="/buseq"
                      className="nav-link px-3 custom-nav-item fw-bold "
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 20,
                      }}
                    >
                      Business Enquiry
                    </NavLink>
            </li>
            <li className="navbar__category nav-item">
              <NavLink
                      to="/web-dev"
                      className="nav-link px-3 custom-nav-item fw-bold "
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 20,
                      }}
                    >
                      Web Development
                    </NavLink>
            </li>

            <li className="navbar__category nav-item">
              <NavLink
                      to="/careerpg"
                      className="nav-link px-3 custom-nav-item fw-bold "
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 20,
                      }}
                    >
                      Career
                    </NavLink>
            </li>
            <li className="navbar__category nav-item">
              <NavLink
                      to="/contacts"
                      className="nav-link px-3 custom-nav-item fw-bold "
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 20,
                      }}
                    >
                      Contact us
                    </NavLink>
            </li>
            <li className="navbar__category nav-item">
              <NavLink
                      to="/events"
                      className="nav-link px-3 custom-nav-item fw-bold "
                      style={{
                        backgroundColor: "black",
                        color: "white",
                        fontSize: 20,
                      }}
                    >
                      Events
                    </NavLink>
            </li>
          </ul>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default MyNavbar;
